// src/components/questions/textQuestion/TextQuestion.jsx
import React, { useState } from "react";
import "./textQuestion.css";

const validators = {
  email: {
    regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    errorMsg: "Ingresa un correo electrónico válido"
  },
  phone: {
    regex: /^[0-9]{0,10}$/,
    errorMsg: "Solo dígitos (hasta 10)"
  },
  height: {
    regex: /^[0-9]*\.?[0-9]*$/,
    validate: val => {
      const n = parseFloat(val);
      return !isNaN(n) && n >= 100 && n <= 240;
    },
    errorMsg: "Altura debe estar entre 100 y 240 cm"
  },
  weight: {
    regex: /^[0-9]*\.?[0-9]*$/,
    validate: val => {
      const n = parseFloat(val);
      return !isNaN(n) && n >= 30 && n <= 250;
    },
    errorMsg: "Peso debe estar entre 30 y 250 kg"
  },
  numeric: {
    // Sólo enteros, al menos un dígito
    regex: /^[0-9]+$/,
    errorMsg: "Solo números enteros"
  }
};

const patterns = {
  email: null,
  phone: /^[0-9]*$/,
  height: /^[0-9]*\.?[0-9]*$/,
  weight: /^[0-9]*\.?[0-9]*$/,
  numeric: /^[0-9]*$/  // permite ir escribiendo dígitos
};

/**
 * TextQuestion ahora es un componente controlado.
 * Recibe `value` desde el padre y notifica cambios con `updateProgress`.
 */
const TextQuestion = ({
  question,
  required,
  updateProgress,
  type = "text",   // puede ser "numeric"
  value = ""
}) => {
  const [error, setError] = useState("");

  const handleChange = e => {
    const val = e.target.value;
    const pattern = patterns[type];
    // si hay pattern y no coincide, no dejamos escribir
    if (pattern && !pattern.test(val)) return;
    if (error) setError("");
    updateProgress(val);
  };

  const handleBlur = () => {
    const trimmed = value.trim();
    if (!trimmed) {
      if (required) setError("Este campo es obligatorio");
      return;
    }
    const config = validators[type];
    if (config) {
      const passesRegex = config.regex.test(trimmed);
      const passesValidate = config.validate ? config.validate(trimmed) : true;
      if (!passesRegex || !passesValidate) {
        setError(config.errorMsg);
      }
    }
  };

  // determinamos tipo de input e inputMode
  const inputType = type === "email" ? "email" : "text";
  const inputMode =
    type === "phone" || type === "numeric"
      ? "numeric"
      : type === "height" || type === "weight"
      ? "decimal"
      : undefined;

  return (
    <div className="text-question">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <input
        type={inputType}
        inputMode={inputMode}
        className={`text-input ${error ? 'input-error' : ''}`}
        placeholder="Responde aquí"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default TextQuestion;
